import { Grid, Typography } from "@mui/material";
import { ReactNode } from "react";

type Props = {
  label: string;
  children: ReactNode;
  labelMinWidth?: string;
};

const TalentInfoRow = ({ label, children, labelMinWidth }: Props) => (
  <Grid container alignItems="center" columnGap={2} py="10px">
    <Grid item>
      <Typography
        textTransform="uppercase"
        fontWeight="700"
        fontSize="14px"
        variant="header"
        lineHeight="16.8px"
        minWidth={labelMinWidth}
      >
        {label}
      </Typography>
    </Grid>
    <Grid xs item>{children}</Grid>
  </Grid>
);

export default TalentInfoRow;
